export default __webpack_public_path__ + "static/media/giftbox.549aba20.svg";